import { on } from '@ngrx/store';
import * as OrderHistoryActions from '../../analytics/actions/admin-order-history.actions';
import { AnalyticsState } from './analytics.reducer';

export const orderHistoryReducers = [
    // Order History Actions
    on(OrderHistoryActions.loadOrders, (state: AnalyticsState) => ({
        ...state,
        loading: true,
        error: null,
        success: false,
    })),

    on(OrderHistoryActions.loadOrdersSuccess, (state: AnalyticsState, { orders }) => {
        return { ...state, ordersHistoryResponse: { ...orders }, loading: false, error: null };
    }),

    on(OrderHistoryActions.loadOrdersFailure, (state: AnalyticsState, { error }) => ({
        ...state,
        loading: false,
        error,
    })),

    on(OrderHistoryActions.exportOrdersHistory, (state: AnalyticsState) => ({ ...state, error: null })),

    on(OrderHistoryActions.exportOrdersHistorySuccess, (state: AnalyticsState) => ({
        ...state,
        success: true,
        error: null,
    })),

    on(OrderHistoryActions.exportOrdersHistoryFailure, (state: AnalyticsState, { error }) => ({ ...state, error })),

    on(OrderHistoryActions.clearOrderHistoryState, (state: AnalyticsState) => ({
        ...state,
        ordersHistoryResponse: null,
        loading: false,
        error: null,
        success: false,
    })),
];
